export default __webpack_public_path__ + "static/media/KB증권.e4042b82.svg";